import { css } from "@emotion/react";

export const heroStyle = css`
  width: 100vw;
  min-height: 620px;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);

  background: url("/images/home-hero.jpg") center / cover no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    min-height: 520px;
  }

  @media (max-width: 768px) {
    min-height: 420px;
  }
`;

export const overlayStyle = css`
  width: 100%;
  min-height: 620px;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.18);

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    min-height: 520px;
    padding: 32px 20px;
  }

  @media (max-width: 768px) {
    min-height: 420px;
    padding: 24px 16px;
  }
`;

export const titleStyle = css`
  margin: 0;
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 64px;
  line-height: 1.08;
  font-weight: 400;
  color: #ffffff;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 46px;
  }

  @media (max-width: 768px) {
    font-size: 30px;
    line-height: 1.15;
  }
`;
